<app-generic-card
  [title]="organization.organizationName"
  [showDescription]="false"
  [showTitle]="false"
  [detailLink]="['/organizations/detail', organization.id]"
  [canEdit]="canOpenEdit()"
  [editLink]="['/organizations/edit', organization.id]"
  [editAriaLabel]="'Modifica organizzazione: ' + organization.organizationName"
>
  <div card-content>
    <div class="small d-flex flex-column gap-2">
      @if (distanceLabel()) {
        <div><i class="bi bi-geo-alt me-2"></i>{{ distanceLabel() }}</div>
      }
      @if (organization.organizationEmail) {
        <div><i class="bi bi-envelope me-2"></i>{{ organization.organizationEmail }}</div>
      }
      @if (organization.organizationPhone) {
        <div><i class="bi bi-telephone me-2"></i>{{ organization.organizationPhone }}</div>
      }
      @if (organization.organizationWebsite) {
        <div>
          <i class="bi bi-globe me-2"></i
          ><a href="{{ organization.organizationWebsite }}" target="_blank">{{
            organization.organizationWebsite
          }}</a>
        </div>
      }
      <div>
        <i class="bi bi-check-circle me-2"></i
        >{{ organization.organizationActive ? 'Attiva' : 'Inattiva' }}
      </div>

      @if (organization.member) {
        <div class="mt-2">
          <span class="badge bg-info">Membro</span>
          @if (organization.moderator) {
            <span class="badge bg-warning">Moderatore</span>
          }
          @if (organization.admin) {
            <span class="badge bg-primary">Admin</span>
          }
          @if (organization.owner) {
            <span class="badge bg-success">Proprietario</span>
          }
        </div>
      }
    </div>
  </div>

</app-generic-card>
